import { useEffect, useState } from 'react'
import { useScreenWidth } from '@/common/hooks/useScreenWidth'

export interface UsePreventScrollOptions {
    /**
     * Viewport breakpoint above which this modal is not rendered;
     * Used to release body scroll if the modal disappears due to resize/zoom while still open in state.
     */
    maxVisibleBreakpoint?: number
    onClose?: () => void
}

export const usePreventScroll = (isMenuOpen: boolean, options: UsePreventScrollOptions = {}) => {
    const [lastState, setLastState] = useState(false)
    const { maxVisibleBreakpoint, onClose } = options
    const screenWidth = useScreenWidth()

    useEffect(() => {
        if (isMenuOpen === lastState) {
            return
        }

        setLastState(isMenuOpen)
        if (isMenuOpen) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'unset'
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- As intended
    }, [isMenuOpen])

    useEffect(() => {
        if (!maxVisibleBreakpoint || !isMenuOpen) return

        const shouldPreventScroll = isMenuOpen && screenWidth < maxVisibleBreakpoint
        document.body.style.overflow = shouldPreventScroll ? 'hidden' : 'unset'

        // If menu is still opened, but not longer displayed on the UI due to breakpoint change
        if (!shouldPreventScroll) {
            onClose?.()
        }
    }, [isMenuOpen, maxVisibleBreakpoint, onClose, screenWidth])
}
